import React, { useMemo, useState } from 'react';
import { RendezVousReplay, parseRendezVousReplayLink, openRendezVousForPolice } from '../shared/activity-viewer';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.monalerte.app';

/**
 * Relecture d'un rendez-vous partagée par un administrateur MonAlerte (service
 * de police…) : le lien porte le sel, le mot de passe est transmis à part. Tout
 * est déchiffré dans ce navigateur ; le serveur ne voit ni le mot de passe ni la clé.
 */
export default function PoliceRendezVousPage() {
  const link = useMemo(() => parseRendezVousReplayLink(window.location.href), []);
  const [password, setPassword] = useState('');
  const [state, setState] = useState({ loading: false, error: '', opened: null });

  const open = async event => {
    event.preventDefault();
    setState({ loading: true, error: '', opened: null });
    try {
      const opened = await openRendezVousForPolice({ apiUrl: API_URL, rdvId: link.rdvId, password: password.trim(), salt: link.salt, iterations: link.iterations });
      setPassword('');
      setState({ loading: false, error: '', opened });
    } catch (error) {
      setState({ loading: false, error: /refusé|403|401|déchiffr|OperationError/i.test(error.message || error.name) ? 'Mot de passe incorrect, ou lien expiré ou révoqué.' : (error.message || 'Ouverture impossible.'), opened: null });
    }
  };

  if (!link) {
    return (
      <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24, background: '#0A192F', color: '#E0E0E0' }}>
        <p>Lien de relecture incomplet : utilisez le lien exact transmis par MonAlerte.</p>
      </main>
    );
  }

  if (state.opened) {
    const base = `${API_URL}/api/rendez-vous/${encodeURIComponent(link.rdvId)}/enquete`;
    return (
      <RendezVousReplay
        detail={state.opened.detail}
        keys={state.opened.keys}
        apiBaseUrl={API_URL}
        mediaBase={base}
        headers={state.opened.headers}
        evidenceUrl={`${base}/evidence`}
        exportsUrl={`${base}/exports`}
        sourceUrl={base}
        exportedFrom="Lien de relecture MonAlerte protégé par mot de passe"
        header={<strong>Relecture MonAlerte</strong>}
      />
    );
  }

  return (
    <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24, background: '#0A192F', color: '#E0E0E0' }}>
      <form onSubmit={open} style={{ width: '100%', maxWidth: 460, background: '#112240', borderRadius: 16, padding: 28, display: 'grid', gap: 14 }}>
        <h1 style={{ margin: 0, fontSize: '1.4rem' }}>Relecture d’un rendez-vous MonAlerte</h1>
        <p style={{ margin: 0, color: '#A0A0A0', fontSize: '0.95rem' }}>
          Saisissez le mot de passe transmis séparément. Le rendez-vous est déchiffré dans ce navigateur uniquement ;
          chaque ouverture et chaque export du dossier de preuve sont enregistrés.
        </p>
        <input type="password" value={password} onChange={event => setPassword(event.target.value)} autoFocus
          autoComplete="off" spellCheck={false} placeholder="Mot de passe"
          style={{ padding: 12, borderRadius: 10, border: '1px solid #334155', background: '#0A192F', color: '#fff', fontSize: '1rem', letterSpacing: '0.05em' }} />
        <button type="submit" disabled={state.loading || !password.trim()}
          style={{ padding: 12, borderRadius: 10, border: 0, background: '#FACC15', color: '#0A192F', fontWeight: 700, cursor: 'pointer' }}>
          {state.loading ? 'Vérification…' : 'Ouvrir la relecture'}
        </button>
        {state.error && <p role="alert" style={{ margin: 0, color: '#fca5a5' }}>{state.error}</p>}
      </form>
    </main>
  );
}
